import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import LivewireBrand from './common/livewire-brand';
import ExpiredPane from './reset-password-elements/expired-pane';
import ResetForm from './reset-password-elements/reset-form';
import CompletePane from './reset-password-elements/complete-pane';
import ResetPasswordContext, { reducer, defaultState } from './reset-password-elements/context';

const Page = styled.div`
  width: 100vw;
  display: flex;
  ${props => (
    props.theme.isMobile ? `
      flex-direction: column-reverse;
      align-items: center;
      background: ${props.theme.linearGradientDarkThemeRect}
    ` : 'flex-direction: row')};
`;

const ValidPanes = ({ complete }) => (!complete ? <ResetForm /> : <CompletePane />);
ValidPanes.propTypes = { complete: PropTypes.bool.isRequired };

export default function ResetPassword(props) {
  const common = commonProps();
  const [state, dispatch] = React.useReducer(reducer, defaultState);
  const themeState = {
    ...props,
    ...common,
  };

  return (
    <ThemeProvider theme={themeState}>
      <ResetPasswordContext.Provider value={{ state, dispatch }}>
        <Page>
          <LivewireBrand />
          {props.valid ? <ValidPanes complete={state.complete} /> : <ExpiredPane /> }
        </Page>
      </ResetPasswordContext.Provider>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
ResetPassword.propTypes = {
  logo: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
